export const CHARGER_STATUS = new Map([
    ['Available', { label: 'Available', color: '#0A47BA' }],
    ['Charging', { label: 'Charging', color: '#C3D33E' }],
    ['Preparing', { label: 'Preparing', color: '#AB82FF' }],
    ['Finishing', { label: 'Finishing', color: '#07e0f0' }],
    ['Faulted', { label: 'Faulted', color: '#E74D3D' }],
    ['Suspended', { label: 'Suspended', color: '#000000' }],
    ['Others', { label: 'Others', color: '#bdbfbf' }],
  ]);